import {authRequest, formRequest, plainRequest} from './index.js'

export async function auth_user (formData, sign_in){
  let data
  await plainRequest.post(
    '/login', 
    {user: formData}
  ).then(function(result){
    localStorage.setItem('uid', result.headers['authorization'])
    data = {result: result.data, error: false}
  }).catch(function (error){
    console.log('error',error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function auth_sso (formData, sign_in){
  let data
  await authRequest.post(
    '/sso', 
    {user: formData, sign_in}
  ).then(function(result){
    data = {result: result.data, error: false}
  }).catch(function (error){
    console.log('error',error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function register_user (formData) {
  let data 
  await plainRequest.post('/signup', {user: formData})
  .then(function(result){
    localStorage.setItem('uid', result.headers['authorization'])
    data = {result: result.data.user, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })

  return data
}

export async function delete_token () {
  let data 
  await authRequest.delete('/logout').then(function(result){
    localStorage.setItem('uid', result.headers['authorization'])
    data = {result, error: false}
  }).catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  
  let userObj = JSON.parse(localStorage.getItem('user_data'));
  // await formRequest.post(
  //   '/admin/users/'+ userObj.id +'/log_out'
  // ).catch(function (error){
  //   console.log(error)
  //   data = {error: true, result: error.response.data}
  // })

  localStorage.removeItem('uid')
  localStorage.removeItem('user_data')

  return data
}

export async function redirect_sso (){
  let data
  await authRequest.get(
    '/auth_sso'
  ).then(function(result){
    data = {result: result.data, error: false}
  }).catch(function (error){
    console.log('error',error)
    data = {error: true, result: error.response.data}
  })
  return data
}

/**
 * Get secure SSO token for forum authentication.
 * This is the recommended method over redirect_sso().
 * @returns {Object} - Response object with token data or error.
 */
export async function redirect_sso_token() {
  let data
  await authRequest.get(
    '/auth_sso/token'
  ).then(function(result){
    data = {result: result.data, error: false}
  }).catch(function (error){
    console.log('error',error)
    data = {error: true, result: error.response?.data}
  })
  return data
}